import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EfaOccProductReferencesAdapter } from './efa-occ-product-references.adapter';
import { ProductReferencesAdapter } from '@spartacus/core';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: ProductReferencesAdapter,
            useClass: EfaOccProductReferencesAdapter,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OccModule {}
